import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Modal, ModalBody } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { clearFields, Field, reduxForm } from 'redux-form';
import validate from './Validate';
import renderField from '../../../shared/components/form/RenderField';

const ModalChangePassword = (props) => {
  const { t, isOpen, toggle, handleSubmit, dispatch } = props;

  useLayoutEffect(() => {
    dispatch(
      clearFields(
        'ModalChangePassword',
        true,
        true,
        ...['newPassword', 'confirmPassword']
      )
    );
  }, [isOpen]);

  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        className="theme-light modal-dialog--success modal-alert"
        backdrop="static"
      >
        <div className="modal__header card-title">
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            onClick={toggle}
          />
          <h4 className="bold-text  modal__title">
            {t('general.change-password')}
          </h4>
        </div>
        <ModalBody>
          <form className="form" onSubmit={handleSubmit}>
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.new-password')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="newPassword"
                  type="password"
                  component={renderField}
                  placeholder={t('general.placeholders.type-here')}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.confirm-new-password')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="confirmPassword"
                  type="password"
                  component={renderField}
                  placeholder={t('general.placeholders.type-here')}
                />
              </div>
            </div>
            <ButtonToolbar className="modal__footer">
              <Button color="danger" onClick={toggle}>
                {t('general.cancel')}
              </Button>
              <Button color="success" type="submit">
                {t('general.confirm')}
              </Button>
            </ButtonToolbar>
          </form>
        </ModalBody>
      </Modal>
    </div>
  );
};

ModalChangePassword.propTypes = {
  t: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'ModalChangePassword',
  validate,
})(withTranslation('common')(ModalChangePassword));
